import * as React from "react";
import { IPrecatorio } from "src/services/interfaces/IPrecatorio";
import { Row, Col } from "antd";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import { useContext } from "react";
import { AuthContext } from "src/components/context/AuthContext";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import { IQuote } from "src/services/interfaces/trade/precificacao/IQuote";

export function MonitorPrecatoriosQuoteResult(props: { precatorio: IPrecatorio; quote: IQuote }) {
  const { currentUser } = useContext(AuthContext);

  const quote = props.quote;
  return (
    <>
      {currentUser.permissions.userCanSeeCommission && (
        <>
          <Row>
            <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
              <span style={{ fontSize: "15px" }}>{`• Comissão:`}</span>
            </Col>
            <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
              <span style={{ fontSize: "15px" }}>{`${PercentageMask(quote.pricing?.commission?.officer?.userCommissionCalculated?.percentage ?? quote.pricing?.commission?.officer?.full?.percentage, 2, 2)}`}</span>
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
              <span style={{ fontSize: "15px" }}>{`• Valor Comissão:`}</span>
            </Col>
            <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
              <span style={{ fontSize: "15px" }}>{`${MoneyMask(quote.pricing?.commission?.officer?.userCommissionCalculated?.value ?? quote.pricing?.commission?.officer?.full?.value)}`}</span>
            </Col>
          </Row>
        </>
      )}
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• Preço:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${MoneyMask(quote.pricing.price)}`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• Percentual do Credor:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}> {`${quote.pricing.isReducedPercentLender ? PercentageMask(quote.pricing.reducedPercentLender, 2, 2) : 100 + "%"}`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• Principal:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${MoneyMask(quote.pricing.principal)}`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• Juros:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${MoneyMask(quote.pricing.interest)}`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• PSS:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${quote.pricing.pss}%`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• Processo:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${quote.precatorio.processCode}`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• Requerente:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${quote.precatorio.requester}`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• CPF/CNPJ:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${quote.precatorio.cpfCnpj}`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• Tribunal:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${quote.precatorio.court}`}</span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={{ span: 8, offset: 4 }}>
          <span style={{ fontSize: "15px" }}>{`• Correction Type:`}</span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={{ span: 10, offset: 2 }}>
          <span style={{ fontSize: "15px" }}>{`${quote.precatorio.correctionType}`}</span>
        </Col>
      </Row>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/pages/monitor/precatorios/MonitorPrecatoriosQuoteResult.tsx